export enum DirectionPreferenceStatusEnum {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  PAUSED = 'paused'
}

export enum RideSearchStatusEnum {
  SEARCHING = 'searching',
  EXPANDING_RADIUS = 'expanding_radius',
  DRIVERS_FOUND = 'drivers_found',
  NO_DRIVERS_FOUND = 'no_drivers_found',
  TIMEOUT = 'timeout',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled'
}

export enum DirectionAlignmentEnum {
  PERFECT_MATCH = 'perfect_match', // 90-100% alinhamento
  GOOD_MATCH = 'good_match', // 70-89% alinhamento
  FAIR_MATCH = 'fair_match', // 50-69% alinhamento
  POOR_MATCH = 'poor_match', // 30-49% alinhamento
  NO_MATCH = 'no_match' // 0-29% alinhamento
}

export enum DriverSelectionCriteriaEnum {
  DISTANCE_ONLY = 'distance_only', // apenas distância ao pickup
  DIRECTION_ONLY = 'direction_only', // apenas alinhamento de direção
  BALANCED = 'balanced', // combinação de distância e direção
  DIRECTION_PRIORITY = 'direction_priority' // prioriza direção sobre distância
}

export interface DirectionCoordinates {
  latitude: number;
  longitude: number;
}

export interface DirectionVector {
  from: DirectionCoordinates;
  to: DirectionCoordinates;
  bearing?: number; // direção em graus (0-360)
  distance?: number; // distância em metros
}

export interface RideDirectionAnalysis {
  rideVector: DirectionVector;
  driverPreferences: DirectionVector[];
  alignmentScores: number[];
  recommendedDrivers: number[];
}

export interface SearchRadiusConfig {
  initial: number;
  increment: number;
  maximum: number;
  maxExpansions: number;
}

export interface DirectionSearchMetrics {
  totalSearches: number;
  averageSearchTime: number;
  successRate: number;
  averageExpansions: number;
  driverResponseRate: number;
}